import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import '../App.css';
 
function PaymentResult() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshCredits } = useAuth();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Processing your payment...');
 
  useEffect(() => {
    const paymentStatus = searchParams.get('status');
    const txnid = searchParams.get('txnid');
    const amount = searchParams.get('amount');
    const error = searchParams.get('error');
 
    console.log('Payment Result:', { paymentStatus, txnid, amount, error });
 
    if (paymentStatus === 'success') {
      setStatus('success');
      setMessage('Payment Successful!');
      refreshCredits();
     
    } else if (paymentStatus === 'failure') {
      setStatus('failure');
      setMessage('Payment Failed');
     
    } else if (paymentStatus === 'error') {
      setStatus('error');
      setMessage('Payment Verification Failed');
    }
  }, [searchParams, refreshCredits]);
 
  return (
    <div className="fb-page-wrapper">
      <div style={{border:"1px solid #ffd700"}} className="fb-main-container">
        <div className="fb-top-section">
          <button className="fb-close-button" onClick={() => navigate('/home')}>×</button>
         
          <div className="payment-result-icon">
            {status === 'loading' && <div className="fb-type-emoji">⏳</div>}
            {status === 'success' && <div className="fb-type-emoji">✅</div>}
            {status === 'failure' && <div className="fb-type-emoji"></div>}
            {status === 'error' && <div className="fb-type-emoji">⚠️</div>}
          </div>
         
          <h1 className="heading">{message}</h1>
         
        </div>
 
        {/* Payment Details Section */}
        <div className="fb-input-form">
          {status === 'success' && (
            <>
              <div className="payment-success-badge">
                <span className="dimond">💎</span>
                <span>Credits added to your account!</span>
              </div>
 
              <div className="fb-form-group">
                <div className="payment-info-row">
                  <span className="payment-info-label">Transaction ID:</span>
                  <span className="payment-info-value">{searchParams.get('txnid')}</span>
                </div>
                <div className="payment-info-row">
                  <span className="payment-info-label">Amount Paid:</span>
                  <span className="payment-info-value payment-amount">₹{searchParams.get('amount')}</span>
                </div>
              </div>
            </>
          )}
 
          {status === 'failure' && (
            <>
              <p className="refer-subtitle">Your payment could not be processed. Please try again.</p>
             
              <div className="fb-form-group">
                <div className="payment-info-row">
                  <span className="payment-info-label">Transaction ID:</span>
                  <span className="payment-info-value">{searchParams.get('txnid')}</span>
                </div>
                {searchParams.get('error') && (
                  <div className="payment-info-row">
                    <span className="payment-info-label">Error:</span>
                    <span className="payment-info-value payment-error">{searchParams.get('error')}</span>
                  </div>
                )}
              </div>
            </>
          )}
 
          {status === 'error' && (
            <>
              <p className="refer-subtitle">
                We couldn't verify your payment. Please contact support with this transaction ID:
              </p>
             
              <div className="fb-form-group">
                <div className="payment-txn-box">
                  <span className="payment-txn-id">{searchParams.get('txnid')}</span>
                </div>
              </div>
 
              <div className="payment-support-box">
                <p className="payment-support-label">📞 Support Contact:</p>
                <p className="payment-support-number">+91 8866822366</p>
                <p className="payment-support-name">Hemant Rathore</p>
              </div>
            </>
          )}
 
          {/* Action Buttons */}
          {status !== 'loading' && (
            <div className="fb-button-group">
              <button
                type="button"
                className="credit-package"
                onClick={() => navigate('/home')}
              >
                <span className="fb-type-emoji">🏠</span>
                <span className="fb-type-heading">Home</span>
              </button>
 
              <button
                type="button"
                className="credit-package"
                onClick={() => navigate('/credits')}
              >
                <span className="fb-type-emoji">💎</span>
                <span className="fb-type-heading">Credits</span>
              </button>
 
              <button
                type="button"
                className="credit-package"
                onClick={() => navigate('/feedback')}
              >
                <span className="fb-type-emoji">💬</span>
                <span className="fb-type-heading">Feedback</span>
              </button>
            </div>
          )}
 
          {/* Security Info */}
          <p className="refer-subtitle nomargin">
            🔒 Secure payment powered by PayU • 256-bit SSL encryption
          </p>
        </div>
      </div>
    </div>
  );
}
 
export default PaymentResult;